import { render } from "./UserValidation.vue?vue&type=template&id=75256f25"
import script from "./UserValidation.vue?vue&type=script&lang=js"
export * from "./UserValidation.vue?vue&type=script&lang=js"
script.render = render

export default script